import usePropertyRef from './usePropertyRef';

const noop = () => undefined;

export default (callable, defaultCallable = noop) =>
    usePropertyRef(typeof callable === 'object' && callable !== null ? callable.current : callable, defaultCallable);
